<template>
  <main>
    <header class="status">
      <h3>{{info.status}}</h3>
      <p v-if="info.isPaid === 0">订单已经成功提交，请在2小时内支付，超时订单可能将被释放或取消。</p>
    </header>
    <section class="box">
      <h4><span>{{ info.ProductName }}</span></h4>
      <ul class="info">
        <li><span>订单号码：</span><b>{{ info.OrderNO }}</b></li>
        <li><span>下单时间：</span><b>{{ info.created_at }}</b></li>
        <li><span>出发日期：</span><b class="bold">{{ info.UserDateTime }}</b></li>
      </ul>
    </section>
    <section class="box" v-if="info.express_deliverys.length > 0">
      <h4><span>邮寄信息</span></h4>
      <ul class="info">
        <li v-for="v in info.express_deliverys" :key="v.id"><span>{{ v.class_id === 165 ? '资料邮寄' : '签证回寄' }}：</span><b>{{ v | getAddress }}</b></li>
      </ul>
    </section>
    <!-- <section class="box">
      <h4><span>联系人</span></h4>
      <ul class="info">
        <li><span>姓名：</span><b>{{info.CustomerName}}</b></li>
        <li><span>电话：</span><b>{{info.Moblie}}</b></li>
        <li><span>备注：</span><b>{{info.remark || '--'}}</b></li>
      </ul>
    </section> -->
    <section class="box">
      <h4><span>价格清单</span></h4>
      <nav>
        <a>项目名称</a>
        <!-- <a>项目数量</a> -->
        <a>项目价格</a>
      </nav>
      <ul class="list">
        <li>
          <span>订单费用</span>
          <span class="add">{{info.visaAmount}}</span>
        </li>
        <li v-show="info.InsAmount">
          <span>保险费用</span>
          <span>{{info.InsAmount}}</span>
        </li>
        <li v-show="info.coupon_deduct_amount">
          <span>优惠券抵扣</span>
          <span>{{info.coupon_deduct_amount}}</span>
        </li>
        <li v-show="info.express_data_amount">
          <span>资料快递</span>
          <span>{{info.express_data_amount}}</span>
        </li>
        <li v-show="info.post_back_amount">
          <span>资料回邮</span>
          <span>{{info.post_back_amount}}</span>
        </li>
        <li v-show="info.cs_points_deduct_amount">
          <span>积分抵扣</span>
          <span>{{info.cs_points_deduct_amount}}</span>
        </li>
        <li v-show="info.other_amount">
          <span>其他费用</span>
          <span>{{info.other_amount}}</span>
        </li>
        <li v-show="info.pending_amount">
          <span>待审核费用</span>
          <span>{{info.pending_amount}}</span>
        </li>
        <li v-show="info.receipt_amount">
          <span>已支付费用</span>
          <span>{{info.receipt_amount}}</span>
        </li>
      </ul>
      <p class="price">{{info.total_amount | toFixed}}</p>
    </section>
    <section class="box">
      <h4><span>支付方式</span></h4>
      <ul class="pay">
        <li @click="payType = 'wx'">
          <figure><i class="icon-wechat_pay"></i><span>微信支付</span></figure>
          <i class="icon-check" :class="{ on: payType === 'wx' }"></i>
        </li>
        <li @click="payType = 'zfb'">
          <figure><i class="icon-zhifubao"></i><span>支付宝支付</span></figure>
          <i class="icon-check" :class="{ on: payType === 'zfb' }"></i>
        </li>
      </ul>
    </section>
    <footer @click="goPay">立即支付</footer>
    <div class="dialog" :class="{on: showPop}">
      <div class="cont">
        <h4><span>{{ payType === 'wx' ? '微信' : '支付宝' }}支付</span><i class="icon-close" @click="togglePop"></i></h4>
        <vue-qrcode v-if="payUrl" :width="250" :margin="2" :value="payUrl"/>
        <p>扫一扫，进行支付</p>
      </div>
    </div>
  </main>
</template>

<script>
import VueQrcode from 'vue-qrcode';
import $qrcode from 'qrcode';
import $pay from '@api/pay';
export default {
  components: {
    VueQrcode
  },
  data () {
    return {
      type: 'visa',
      orderNo: null,
      info: {
        express_deliverys: []
      },
      payType: 'wx',
      showPop: false,
      payUrl: null,
    }
  },
  created () {
    const { orderNo, type = 'visa' } = this.$route.query;
    if ( !orderNo ) {
      this.$router.push({ name: 'home' });
      return;
    }
    this.orderNo = orderNo;
    this.type = type;
    this.getInfo();
  },
  filters: {
    getAddress (_) {
      const { 
        m_company_name, r_company_name,
        m_contact_tel, r_contact_tel,
        m_pro, r_pro,
        m_city, r_city,
        m_area, r_area,
        m_address, r_address
      } = _;
      return `${ m_company_name || r_company_name }-${m_contact_tel||r_contact_tel}-${m_pro || r_pro}-${m_city||r_city}-${m_area||r_area}-${m_address||r_address}`;
    },
    toFixed (val, num = 2) {
      return parseFloat(Number(val).toFixed(num));
    }
  },
  methods: {
    async goPay () {
      const { payType } = this;
      let res = '';
      const { type, orderNo } = this;
      switch (payType) {
        case 'wx': 
          // 微信支付
          res = `https://h5.cstravel.cn/api/v2/Yspay/wxJs?order_type=${type}&order_sn=${orderNo}`;
          break;
        case 'zfb': 
          // 支付宝
          const data = await $pay.payInfo({ order_sn: orderNo, type });
          const { source_qr_code_url, trade_no } = data;
          res = `${source_qr_code_url}?test=${trade_no}`;
          break;
      }
      this.payUrl = res;
      this.togglePop();
    },
    async pay () {
      const { OrderNO } = this.info;
      const data = {
        order_type: 'visa',
        order_sn: OrderNO,
        payment_type: 'YspayWeixinPay'
      };
      const res = await this.$axios.get('Yspay/request', { params: data });
    },
    async getInfo () {
      const { orderNo } = this;
      const info = await this.$axios.get('VisaOrder/getOrderByUser', { params: { OrderNO: orderNo } });
      this.info = info;
    },
    togglePop () {
      this.showPop = !this.showPop;
    }
  }
}
</script>

<style scoped src="./pay.css"></style>